import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CanActivateLoginGuard } from "../app.services/login/services/can.activate.login.provider";
import { GlobalAppProvidersModule } from "./global.app.providers";
import { ROUTES } from "./routes/routes";
import { ShellAuthGuard } from "./shell/services/shell-auth-guard";

export let __ris_global_vars__:any;




@NgModule({
	imports: [
		RouterModule.forRoot(ROUTES),
		GlobalAppProvidersModule
	],
	exports: [
		RouterModule
	],
	providers: [
		ShellAuthGuard,
		CanActivateLoginGuard,
	]
})
export class APPRoutingModule { }
